import React from 'react'
import classNames from 'classnames'
import { compose } from 'recompose'

import Dropdown from 'components/base/Dropdown'
import { UserRowFromId } from 'components/Users/UserRow'
import { providesChannelMemberships } from 'components/Channels/dataSync/channelMembers'

const MetaUsersListBody = compose(providesChannelMemberships)(
  ({ userIds, numUsers = 0 }) => {
    return (
      <Dropdown.Body placement="left">
        <Dropdown.Title>{numUsers} users are on this doc</Dropdown.Title>
        <Dropdown.Menu scrolling className="background-shade-100">
          {userIds
            .map((userId, index) => (
              <UserRowFromId
                key={userId}
                userId={userId}
                className="margin-vertical-normal margin-horizontal-medium"
              />
            ))
            .toArray()}
        </Dropdown.Menu>
      </Dropdown.Body>
    )
  }
)

function MetaUsersList({ channelId, userIds, numUsers = 0, limit = 3 }) {
  return (
    <Dropdown>
      {({
        getRootProps,
        getButtonProps,
        getInputProps,
        getItemProps,
        inputValue,
        highlightedIndex,
        isOpen,
      }) => (
        <Dropdown.Wrapper {...getRootProps({ refKey: 'innerRef' })}>
          <div
            {...getButtonProps()}
            className={classNames([
              'flexbox flexbox-align-center flexbox-justify-center margin-top-small',
              'bold shade-30 background-shade-50 radius-round font-weight-large center-text',
              'pointer',
            ])}
            style={{ width: 24, height: 24, fontSize: 11 }}
          >
            + {numUsers - limit}
          </div>
          {isOpen && (
            <MetaUsersListBody
              channelId={channelId}
              userIds={userIds}
              numUsers={numUsers}
            />
          )}
        </Dropdown.Wrapper>
      )}
    </Dropdown>
  )
}

export default MetaUsersList
